<template>
  <div class="table-tile">
    <div class="table-tile__item">
      <div class="table-tile__item-block block-code">
        <span class="label">{{ $t('rma.code') }}: </span>
        <span class="value">{{ item.id }}</span>
      </div>
      <div class="table-tile__item-block block-order-code">
        <ul class="rma-orders nav">
          <li v-for="order in item.orders" :key="order.order_number">
            <router-link class="bcm-link bcm-link-none link-order" :to="{ name: 'myOrder', params: { id: order.order_id }}">
              <span class="label">{{ $t('rma.order') }}: </span>
              <span class="value">{{ order.order_number }}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="table-tile__item-block block-status">
        <span class="label">{{ $t('rma.status') }}: </span>
        <span class="value">{{ item.status_name }}</span>
      </div>
      <div class="table-tile__item-block block-create_at">
        <span class="label">{{ $t('rma.created-at') }}: </span>
        <span class="value">{{ item.created_at }}</span>
      </div>
      <div class="table-tile__item-block block-actions block-latest">
        <router-link :to="{ name: 'editReturns', params: { id: item.guest_id } }" v-t="'rma.viewReturn'" class="bcm-link bcm-link-bolded"/>
      </div>
    </div>
  </div>
</template>

<script>
import ImgProduct from 'theme/components/Product/Image'

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ImgProduct
  }
}
</script>
